<template>
  <div class="border-b border-grey-light py-2 px-4">
    <div
      v-if="title"
      class="uppercase text-blue-light mb-2 text-xs"
    >
      {{ title }}
    </div>
    <div
      v-if="body"
      class="w-full text-sm"
    >
      {{ body }}
    </div>
    <div
      v-if="timeDiff"
      class="text-blue-light text-xs"
    >
      {{ timeDiff }}
    </div>
  </div>
</template>
<script>

export default {
  name: 'VNotificationItem',
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  computed: {
    title() {
      switch (this.notification.title) {
        case 'gdt-events':
          return 'Global Dairy Trade Event';
        case 'retail-consumption':
          return 'Retail Price Consumption';
        case 'worldwide-cheese-quotations':
          return 'Worldwide Cheese Quotations';
        case 'worldwide-quotations':
          return 'Worldwide Quotations';
        case 'milk-productions':
          return 'Milk Productions';
      }
      return '';
    },
    timeDiff() {
      return this.notification.time_diff;
    },
    body() {
      return this.notification.body || '';
    },
  },
};
</script>
